   // Defer retargeting script
        window.addEventListener('load', function () {
            
          var script = document.createElement('script');
          script.src = '//s.retargeted.co/1/xoOjbx.js';
          script.async = true;
          document.head.appendChild(script);
        });